module.exports = __webpack_public_path__ + "img/2x3_border.88ea096d.jpg";